routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true);
	$stateProvider
	.state('report', {
		abstract: false,
		url: '/report',
		redirectTo: 'report.reportList',
		views: {
			'': {
				template: require('../../../layout/layout.html')
			},
			'content': {
				template: require('../../../layout/content.html'),
			},
			'aside': {
				template: require('../../../layout/aside.html'),
				controller: 'AsideCtrl'
			},
			'header': {
				template: require('../../../layout/header.html'),
				controller: 'HeaderCtrl'
			},
	      	'chatbox': {
		        template: require('../chatbox/chatbox.html'),
		        controller: 'ChatboxController',
		        controllerAs: 'chatbox'
	      	},
		    'footer': {
		        template: require('../../../layout/footer.html')
		    }
		},
		data: {
			displayName: 'Inicio'
		}
	})
	.state('report.staticReport', {
		abstract: false,
		url: '/static',
		template: require('./static/staticReport.html'),
		controller: 'StaticReportCtrl',
		controllerAs: 'staticReportVM',
		data: {
			displayName: 'Reportes Estáticos'
		}
	})
	.state('report.reportList', {
		abstract: false,
		url: '/list',
		template: require('./list/reportList.html'),
		controller: 'ReportListCtrl',
		controllerAs: 'reportListVm',
		params:{
			globalView: true
		},
		data: {
			displayName: 'Reportes'
		}
	})
	.state('report.reportGlobal', {
		abstract: false,
		url: '/list-global',
		template: require('./list/reportList.html'),
		controller: 'ReportListCtrl',
		controllerAs: 'reportListVm',
		params:{
			globalView: false
		},
		data: {
			displayName: 'Reportes'
		}
	})
	.state('report.powerbiWorkPlan', {
      abstract: false,
      url: '/workplanPowerbi',
      template: require('./reportWorkPlanPowerbi/powerbiWorkPlan.html'),
      controller: 'powerbiWorkPlanCtrl',
      controllerAs: 'pbWpCtrl'      
    }) 
}


// WEBPACK FOOTER //
// ./src/app/u-faculty/report/report.route.js